import React from "react";
import Footer from "./footer";
import { useLanguage } from "../LanguageContext";
import { BookAlert, FileText } from "lucide-react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import brochure1Img from "../assets/products/das/brosur1.jpg";
import brochure2Img from "../assets/products/das/brosur2.jpg";
import brochure3Img from "../assets/products/das/brosur3.jpg";
import userManualPDF from "../assets/usermanual/usermanual_das24.pdf";

const ProductDetail = () => {
  const { language } = useLanguage();

  const text = {
    en: {
      title: "Digital Alert System 24P",
      subtitle: "A device with a system that can provide warnings regarding the condition of equipment in the main substation with 24 Channel Digital Input.",
      download: "Download the brochure",
      manual: "Download the User Manual",
      specTitle: "Specification",
      features: [
        { icon: require("../assets/products/das/admin.png"), label: "Easy to use configuration UI" },
        { icon: require("../assets/products/das/monitor.png"), label: "Remote management over web browser HMI Server" },
        { icon: require("../assets/products/das/input.png"), label: "Digital input 48VDC/110VDC" },
        { icon: require("../assets/products/das/logdata.png"), label: "Data Logger" },
      ],
      specs: [
        { title: "Installation", desc: "DIN-Rail" },
        { title: "Input Current Max", desc: "2A" },
        {
          title: "Dimension",
          desc: [
            "158 x 110 x 50mm for DAS24P version",
          ],
        },
        {
          title: "Input Voltage",
          desc: [
            "12VDC-55VDC for 48VDC Series",
          ],
        },
        {
          title: "Interfaces",
          desc: [
            ["RJ45 Port", "10/100 Base Ethernet Socket"],
            ["LED Indicators", "Power, Link, Alarm"],
            ["USB Ports", "4x USB 2.0 Connector"],
            ["Digital Input Connector", "24-Pin 5.08mm for DAS24P"],
          ],
        },
      ],
      docsTitle: "Documentation",
      docs: [
        { title: "ULTG YOGYAKARTA", desc: "DAS 110VDC Installation", img: "dasdoc1.png" },
        { title: "ULTG YOGYAKARTA", desc: "DAS 110VDC Installation", img: "dasdoc2.png" },
      ],
    },
    id: {
      title: "Digital Alert System 24P",
      subtitle: "Perangkat dengan sistem yang dapat memberikan peringatan mengenai kondisi peralatan di gardu induk dengan 24 channel digital input.",
      download: "Unduh Brosur",
      manual: "Unduh Panduan Pengguna",
      specTitle: "Spesifikasi",
      features: [
        { icon: require("../assets/products/das/admin.png"), label: "Antarmuka konfigurasi mudah digunakan" },
        { icon: require("../assets/products/das/monitor.png"), label: "Manajemen jarak jauh via HMI Server berbasis web" },
        { icon: require("../assets/products/das/input.png"), label: "Input digital 48VDC/110VDC" },
        { icon: require("../assets/products/das/logdata.png"), label: "Pencatat Data" },
      ],
      specs: [
        { title: "Installation", desc: "DIN-Rail" },
        { title: "Input Current Max", desc: "2A" },
        {
          title: "Dimension",
          desc: [
            "158 x 110 x 50mm for DAS24P version",
            "300 x 110 x 50mm for DAS24P version",
          ],
        },
        {
          title: "Input Voltage",
          desc: [
            "12VDC-55VDC for 48VDC Series",
            "85VDC-240VDC for 110VDC Series",
          ],
        },
        {
          title: "Interfaces",
          desc: [
            ["RJ45 Port", "10/100 Base Ethernet Socket"],
            ["LED Indicators", "Power, Link, Alarm"],
            ["USB Ports", "4x USB 2.0 Connector"],
            ["Digital Input Connector", "48-Pin 8.89mm for DAS48P"],
          ],
        },
      ],
      docsTitle: "Dokumentasi",
      docs: [
        { title: "ULTG YOGYAKARTA", desc: "Pemasangan DAS 110VDC", img: "dasdoc1.png" },
        { title: "ULTG YOGYAKARTA", desc: "Pemasangan DAS 110VDC", img: "dasdoc2.png" },
      ],
    },
  };

  const t = text[language] || text.en;

  const handleDownloadPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    const images = [brochure1Img, brochure2Img, brochure3Img];

    let loaded = 0;
    const loadedImages = [];

    images.forEach((src, index) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedImages[index] = img;
        loaded++;

        if (loaded === images.length) {
          loadedImages.forEach((img, i) => {
            const imgWidth = pageWidth;
            const imgHeight = (img.height * imgWidth) / img.width;
            const y = imgHeight < pageHeight ? (pageHeight - imgHeight) / 2 : 0;

            if (i > 0) pdf.addPage();
            pdf.addImage(img, "JPEG", 0, y, imgWidth, imgHeight);
          });

          pdf.save("DAS24-Brochure.pdf");
        }
      };
    });
  };

  const handleDownloadManual = async () => {
    try {
      const response = await fetch(userManualPDF); 
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

   
      a.download = "mel_usermanual_das42.pdf";

      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };



 return (
    <div className="font-inter text-gray-900 px-4 sm:px-8 md:px-20 lg:px-40">
      <section
        className="relative flex flex-col md:flex-row-reverse items-center justify-between 
             px-4 sm:px-6 md:px-10 py-10 sm:py-14 md:py-20 
             mx-4 sm:mx-6 md:mx-10 
             mt-20 sm:mt-14 md:mt-20 
             overflow-hidden rounded-[40px] 
             shadow-[0_25px_60px_rgba(55,140,231,0.5)]"
        style={{
          background:
            "linear-gradient(100deg, #DFF5FF 10%, #FFFFFF 40%, #2652A4 100%)",
        }}
      >
        <div className="w-full md:w-1/2 mb-6 md:mb-0 flex justify-center z-10">
          <img
            src={require("../assets/products/das/DAS.png")}
            alt={t.title}
            className="w-full max-w-[700px] sm:max-w-[800px] object-contain drop-shadow-[0_20px_50px_rgba(55,140,231,0.6)] transition-transform duration-500 ease-out"
          />
        </div>
        <div className="w-full md:w-1/2 z-20 text-left text-[#1446A5] md:pr-10 sm:md:pr-20">
          <h1 className="text-2xl sm:text-3xl md:text-3xl font-extrabold mb-4 sm:mb-6 leading-snug">
            {t.title} <br />
            <span className="text-[#1446A5] drop-shadow-md">DAS 24P</span>
          </h1>

          <h2 className="text-lg sm:text-xl md:text-lg opacity-100 font-medium mb-4 sm:mb-6 leading-relaxed max-w-[400px] sm:max-w-[480px]">
            {t.subtitle}
          </h2>

          <div className="flex justify gap-4">

            <button
              onClick={handleDownloadPDF}
              className="bg-[#2652A4] text-white font-medium text-sm px-3 py-2 rounded-full shadow-md hover:shadow-lg flex items-center gap-1 transition-all hover:scale-105"
            >
              {t.download}
              <FileText className="w-4 h-5" />
            </button>

            <button
              onClick={handleDownloadManual}
              className="bg-[#2652A4] text-white font-medium text-sm px-3 py-2 rounded-full shadow-md hover:shadow-lg flex items-center gap-1 transition-all hover:scale-105"
            >
              {t.manual}
              <BookAlert className="w-4 h-5" />
            </button>
          </div>

          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
            {t.features.map((f, i) => (
              <div key={i} className="flex flex-col items-center">
                <img
                  src={f.icon}
                  alt={f.label}
                  className="w-8 sm:w-10 md:w-12 mb- " 
                />
                <p className="text-[#1446A5] text-xs sm:text-sm font-medium leading-snug">
                  {f.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="px-4 sm:px-6 md:px-10 py-8 sm:py-12 md:py-18 mt-20">
        <div className="block md:hidden mb-6">
          <h3 className="text-[#1446A5] text-2xl sm:text-3xl font-extrabold leading-loose tracking-widest">
            {t.specTitle}
          </h3>
        </div>

        <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:gap-12">
          <div className="order-2 md:order-2 md:w-1/2 flex flex-col">
            <div className="grid grid-cols-2 gap-3 sm:gap-4 items-stretch text-[12px] sm:text-[14px] md:text-base">
              {t.specs.map((spec, i) => (
                <div
                  key={i}
                  className={`bg-white rounded-lg p-3 sm:p-4 md:p-6 flex flex-col justify-between h-full ${
                    spec.title === t.specs[t.specs.length - 1].title
                      ? "col-span-2 order-2"
                      : "order-1"
                  }`}
                >
                  <div>
                    <div className="font-semibold mb-3 text-[20px]">{spec.title}</div>

                    {Array.isArray(spec.desc) ? (
                      <ul className="mt-1 sm:mt-2 text-gray-700 space-y-1">
                        {spec.desc.map((d, idx) => (
                          <li key={idx} className="text-[20px] sm:text-sm">
                            {d}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="mt-1 sm:mt-2 text-gray-700 text-[20px] sm:text-sm whitespace-pre-line">
                        {spec.desc}
                      </div>
                    )}
                  </div>
                  <div className="mt-2 border-b border-gray-300" />
                </div>
              ))}
            </div>
          </div>

          <div className="order-2 md:order-1 md:w-1/2 flex flex-col justify-between mt-10 md:mt-0">
            <div>
              <h3 className="text-[#1446A5] hidden md:block text-3xl sm:text-4xl md:text-6xl font-extrabold leading-loose tracking-widest mt-14 sm:mt-14 md:mt-32 ml-28">
                {t.specTitle}
              </h3>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProductDetail;
